<template>
  <v-layout>
    <v-flex xs3>
      <p class="row-header">{{ questionData.label }}</p>
    </v-flex>

    <v-flex xs1 v-for="(answer, index) in questionData.answers" v-bind:key="index">
      <!-- <v-text-field name="index" v-model="questionData.answers[index]" prefix="$" @change="updateTotal($event, index)" outline></v-text-field> -->
      <answer-value
        v-bind:value="questionData.answers[index]"
        prefix="$"
        v-bind:name="questionData.id"
        v-bind:index="index"
        v-bind:hasOutline="true"
        v-bind:isReadOnly="false"
        v-on:answerValueUpdated="onAnswerValueUpdated(data)"
      ></answer-value>
    </v-flex>

    <v-flex xs1>
      <v-text-field v-model="total" prefix="$" outline readonly></v-text-field>
    </v-flex>

    <v-flex xs3>
      <v-text-field v-if="isValueReferenced" v-model="q2b2" prefix="$" outline readonly></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "MatrixAnswer",
  props: {
    questionData: Object
  },
  data: () => ({
    total: 0
  }),
  computed: {
    isValueReferenced: function () {
      return !!this.questionData.referencedAnswer;
    }
  },
  methods: {
    onAnswerValueUpdated: function (data) {
      let d = data;
    },
    updateTotal: function (evt, idx) {
      this.total = 0;

      if (!this.questionData || !this.questionData.answers) return 0;

      let values = this.questionData.answers;
      let len = values.length;

      for (let idx = 0; idx < len; idx++) {
        let val = values[idx];

        // Replace util.isString with native check
        if (typeof val === "string") {
          val = parseFloat(val);
        }

        this.total += val;
      }

      this.$emit("columnValueUpdated", evt, idx);
      console.log("Total updated to: " + this.total);
      return this.total;
    }
  }
};
</script>

<style scoped>
.row-header {
  font-weight: bold;
}
</style>
